import APIGateway from './APIGateway';
import { IResponse } from '../types/types';

export class EntityServices<T> extends APIGateway<T> {
    public async GetAllAsync(
        url: string,
        token?: string,
        page?: number,
        itemsPerPage?: number, isDefaultUrl?: boolean
    ): Promise<IResponse | null> {
        if (page && itemsPerPage) {
            const fullUrl = `/${url}?page=${page}&ItemsPerPage=${itemsPerPage}`;
            return await this.GetList(fullUrl, token, isDefaultUrl);
        } else {
            return await this.GetList(url ?? '', token, isDefaultUrl);
        }
    }

    public async GetdataByFilterAsync(url: string, token?: string, isDefaultUrl?: boolean): Promise<IResponse | null> {
        return await this.GetList(url, token, isDefaultUrl);
    }

    public async GetDataByIdAsync(id: number, url: string, token?: string, isDefaultUrl?: boolean): Promise<IResponse | null> {
        return await this.GetById(url, id, token, isDefaultUrl);
    }

    public async GetDataByfilterAsync(url: string, token?: string, isDefaultUrl?: boolean): Promise<IResponse | null> {
        return await this.GetSingle(url, token, isDefaultUrl);
    }

    public async AddAsync<A>(url: string, data: T, token?: string, isDefaultUrl?: boolean): Promise<IResponse | null> {
        return await this.Post(url, data, token, isDefaultUrl);
    }

    public async AddFromAnotherModelAsync<A>(url: string, data: A, token?: string, isDefaultUrl?: boolean): Promise<any> {
        return await this.PostFromAnotherModel<A>(url, data, token, isDefaultUrl);
    }

    public async UpdateAsync(url: string, data: T, id: number | string, token?: string, isDefaultUrl?: boolean): Promise<any> {
        return await this.Put(`${url}/${id}`, data, token, isDefaultUrl);
    }

    public async UpdateFromAnotherModelAsync<A>(
        response: A,
        id: number | string,
        token?: string,
        additionUrl?: string, isDefaultUrl?: boolean
    ): Promise<any> {
        if (additionUrl) {
            return await this.PutFromAnotherModel<A>(`${this.baseUrl}${additionUrl}/${id}`, response, token, isDefaultUrl);
        } else {
            return await this.PutFromAnotherModel<A>(this.baseUrl + id, response, token, isDefaultUrl);
        }
    }

    public async DeleteAsync(url: string, id: number | string, token?: string, isDefaultUrl?: boolean): Promise<any> {
        const response = await this.Delete(url + `/${id}`, token, isDefaultUrl);
        return response ? true : false;
    }
}
